var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "35",
          height: "24",
          fill: "none"
        }
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          fill: "#02016F",
          "fill-rule": "evenodd",
          d:
            "M19.418 10.813a.41.41 0 0 1 .411.41v7.656a.41.41 0 0 1-.41.411h-1.233a.421.421 0 0 1-.411-.41v-7.657a.41.41 0 0 1 .41-.41h1.233Zm-4.008 2.234a.461.461 0 0 1 .46.471v5.301a.461.461 0 0 1-.46.471h-1.152a.451.451 0 0 1-.461-.47v-5.302a.45.45 0 0 1 .46-.47h1.153Zm-4.008 2.275a.44.44 0 0 1 .44.44v3.087a.44.44 0 0 1-.44.441h-1.113a.432.432 0 0 1-.43-.44v-3.087a.441.441 0 0 1 .43-.441h1.113ZM20.61 0a8.939 8.939 0 0 1 8.898 8.969A7.697 7.697 0 0 1 27.365 24h-1.193a.42.42 0 0 1-.42-.42v-1.133a.43.43 0 0 1 .42-.431h1.203a5.692 5.692 0 0 0 .45-11.344.27.27 0 0 1-.25-.26V8.969a7.015 7.015 0 0 0-7.014-7.015 6.934 6.934 0 0 0-6.815 5.742l-.05.441a.43.43 0 0 1-.42.37h-3.007a4.39 4.39 0 0 0-4.168 4.29v1.122a.27.27 0 0 1-.271.27 3.848 3.848 0 0 0-3.728 3.367 3.878 3.878 0 0 0 3.638 4.49h13.728a2.645 2.645 0 0 0 2.295-2.636V8.99a.44.44 0 0 1 .441-.441h1.112a.43.43 0 0 1 .431.44v10.633A4.66 4.66 0 0 1 19.74 24H5.93a5.892 5.892 0 0 1-1.743-11.494 6.453 6.453 0 0 1 5.752-5.842H12.063A8.888 8.888 0 0 1 20.601 0h.01Z",
          "clip-rule": "evenodd"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }